import { render, staticRenderFns } from "./TcmRxCPD2.vue?vue&type=template&id=44ff48b4&scoped=true"
import script from "./TcmRxCPD2.vue?vue&type=script&lang=js"
export * from "./TcmRxCPD2.vue?vue&type=script&lang=js"
import style0 from "./TcmRxCPD2.vue?vue&type=style&index=0&id=44ff48b4&scoped=true&lang=css"
import style1 from "./TcmRxCPD2.vue?vue&type=style&index=1&id=44ff48b4&lang=scss&scoped=true"
import style2 from "./TcmRxCPD2.vue?vue&type=style&index=2&id=44ff48b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ff48b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ff48b4')) {
      api.createRecord('44ff48b4', component.options)
    } else {
      api.reload('44ff48b4', component.options)
    }
    module.hot.accept("./TcmRxCPD2.vue?vue&type=template&id=44ff48b4&scoped=true", function () {
      api.rerender('44ff48b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TCMRx/TcmRxCPD2.vue"
export default component.exports